export default "__VITE_PUBLIC_ASSET__a83d52ad__"